import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/index.less";
import "@/assets/fonts/fonts.css";

import {
  ConfigProvider,
  Tabs,
  Form,
  Input,
  Button,
  Checkbox,
  Space,
  Result,
  Layout,
  Avatar,
  Menu,
  Dropdown,
  Row,
  Col,
  Select,
  Radio,
  Divider,
  Popconfirm,
  Table,
  Modal,
  Cascader,
  Spin,
  DatePicker,
  Steps,
  Tag,
  Card,
  Drawer,
  Upload,
  Progress,
  TreeSelect,
  InputNumber,
  Statistic,
  Empty,
  Tooltip,
  Pagination,
  Carousel,
  Popover,
} from "ant-design-vue";

const app = createApp(App);
app
  .use(router)
  .use(store)
  .use(ConfigProvider)
  .use(Tabs)
  .use(Carousel)
  .use(Form)
  .use(Input)
  .use(Space)
  .use(Checkbox)
  .use(Button)
  .use(Result)
  .use(Layout)
  .use(Avatar)
  .use(Menu)
  .use(Dropdown)
  .use(Row)
  .use(Col)
  .use(Select)
  .use(Radio)
  .use(Divider)
  .use(Popconfirm)
  .use(Table)
  .use(Modal)
  .use(Cascader)
  .use(Spin)
  .use(DatePicker)
  .use(Steps)
  .use(Tag)
  .use(Card)
  .use(Drawer)
  .use(Upload)
  .use(Progress)
  .use(TreeSelect)
  .use(InputNumber)
  .use(Statistic)
  .use(Empty)
  .use(Tooltip)
  .use(Pagination)
  .use(Popover)
  .mount("#portal-site");
// 挂载全局环境变量
app.config.globalProperties._isProduction =
  process.env.VUE_APP_ENV === "production";
